<template>
  <fragment>
    <div image-fill class="container section-inner illustration-section-01">
      <br /><br />
      <h3 v-html="title" style="text-align: center"></h3>
      <div v-html="content" style="padding: 20px"></div>
    </div>

    <c-cta top-divider bottom-divider split />
  </fragment>
</template>

<script>
import CLayout from "@/layouts/LayoutDefault.vue";
import CCta from "@/components/sections/Cta.vue";
import marked from "marked";

export default {
  name: "Home",
  components: {
    CCta,
  },
  data() {
    return {
      title: "",
      content: "",
    };
  },
  created() {
    this.$emit("update:layout", CLayout);
    this.GetDetail();
  },
  watch: {
    $route() {
      this.GetDetail();
    },
  },
  methods: {
    GetDetail() {
      let str = window.location.search;
      let params = new URLSearchParams(str);
      let id = params.get("id");
      let tag = params.get("tag");
      this.$axios
        .get(
          `https://cdn.contentful.com/spaces/${tag}/environments/master/entries/${id}?access_token=wVryCvO_gFJfPY34V4KTn9gDxZeEa3lNWHkra043a7c`
        )
        .then((res) => {
          if (res.data != null) {
            this.title = marked(res.data.fields.title);
            this.content = marked(res.data.fields.markdown);
          }
        });
    },
  },
};
</script>
